import React from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function DemoBanner() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (user?.role !== "demo") return null;
  const keep = async () => { await logout(); navigate("/register"); };
  return (
    <div className="sticky top-0 z-[60] bg-sorted-ink text-white text-xs font-bold px-4 py-2 flex items-center gap-2" data-testid="demo-banner">
      <Sparkles size={14} strokeWidth={2.5} className="text-sorted-rose shrink-0" />
      <span className="flex-1 truncate">Demo family · disappears in 24h · 10 Millie chats & 3 swaps</span>
      <button onClick={keep} className="bg-sorted-rose text-white rounded-full px-3 py-1 active:scale-95 transition-transform" data-testid="demo-signup">Create my own</button>
    </div>
  );
}
